module.exports = __webpack_public_path__ + "img/home_button_zuoye.82e8269a.png";